import gql from 'graphql-tag';

const previewResolver = {
  resolvers: {
    Mutation: {
      runEditMode: (
        _,
        { currentEditProductId, sno },
        { cache, getCacheKey }
      ) => {
        const query = gql`
          query AppSetting {
            app @client {
              drawerOpen
              currentEditProductId
              currentSno
            }
          }
        `;
        const appSetting = cache.readQuery({
          query
        });

        cache.writeQuery({
          query,
          data: {
            app: {
              ...appSetting.app,
              drawerOpen: true,
              currentEditProductId,
              currentSno: sno
            }
          }
        });
      }

      // makeUncompleteStatus: (_, { currentEditProductId: id }, { cache }) => {
      //   const fragment = gql`
      //     fragment CompleteVariablesFragment on ProductInfo {
      //       isCompleted
      //       isNewCompleted
      //     }
      //   `;
      //   const oldIsCompleted = cache.readFragment({
      //     fragment,
      //     id
      //   });
      //   const newData = {
      //     ...oldIsCompleted,
      //     isCompleted: false,
      //     isNewCompleted: false
      //   };

      //   cache.writeData({
      //     id,
      //     data: newData
      //   });
      // }
    }
  }
};

export default previewResolver;



// WEBPACK FOOTER //
// ./src/resolvers/preview.resolver.ts